import * as actionTypes from '../../action/actiontypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    loading: false,
    getPreferenceList: [],
    getPreferenceErrors: [],

    createPreferenceErrors: [],
    createPreferenceSuccess: [],
}

const preferenceReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PREFERENCE_REQUEST:
            return updateObject(state, {
                loading: true,
                getPreferenceList: "",
                getPreferenceErrors: ""
            })

        case actionTypes.GET_PREFERENCE_SUCCESS:
            return updateObject(state, {
                loading: false,
                getPreferenceList: action.payload
            })

        case actionTypes.GET_PREFERENCE_ERROR:
            return updateObject(state, {
                loading: false,
                getPreferenceErrors: action.payload
            })

        // ------------

        case actionTypes.CREATE_PREFERENCE_REQUEST:
            return updateObject(state, {
                loading: true,
                createPreferenceSuccess: "",
                createPreferenceErrors: ""
            })

        case actionTypes.CREATE_PREFERENCE_SUCCESS:
            return updateObject(state, {
                loading: false,
                createPreferenceSuccess: action.payload
            })

        case actionTypes.CREATE_PREFERENCE_ERROR:
            return updateObject(state, {
                loading: false,
                createPreferenceErrors: action.payload
            })

        case actionTypes.EVENT_REQUEST:
            return updateObject(state, {
                loading: true,
                saveEventError: "",
                savedEvent: "",
            });

        case actionTypes.EVENT_SUCCESS:
            return updateObject(state, {
                loading: false,
                savedEvent: action.payload,
            });

        case actionTypes.EVENT_ERROR:
            return updateObject(state, {
                loading: false,
                saveEventError: action.payload,
            });

        // Fetch Event Data
        case actionTypes.FETCH_EVENT_REQUEST:
            return updateObject(state, {
                loading: true,
                fetchEventError: "",
                event: "",
            });

        case actionTypes.FETCH_EVENT_SUCCESS:
            return updateObject(state, {
                loading: false,
                event: action.payload,
            });

        case actionTypes.FETCH_EVENT_FAILURE:
            return updateObject(state, {
                loading: false,
                fetchEventError: action.payload,
            });

        case actionTypes.DELETE_EVENT_REQUEST:
            return updateObject(state, {
                deleteLoading: true,
                deleteEventError: "",
                deleteEvent: "",
            });

        case actionTypes.DELETE_EVENT_SUCCESS:
            return updateObject(state, {
                deleteLoading: false,
                deleteEvent: action.payload,
            });

        case actionTypes.DELETE_EVENT_FAILURE:
            return updateObject(state, {
                deleteLoading: false,
                deleteEventError: action.payload,
            });
        default:
            return state
    }
}

export default preferenceReducer